// extracted by mini-css-extract-plugin
export default {"haveClaim":"responsiveStyles_haveClaim__txYUJ","haveClaimInner":"responsiveStyles_haveClaimInner__DBwPn"};